import { useState } from 'react';

import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

function readUrlParam(name) {
    if (typeof window === 'undefined') return '';
    try {
        return (new URLSearchParams(window.location.search).get(name) || '').trim().slice(0, 50);
    } catch (error) {
        return '';
    }
}

function AuthSection() {
    // Пришли по ссылке из статьи с промокодом или по приглашению ?ref= — сразу открываем регистрацию
    const [promoFromUrl] = useState(() => readUrlParam('promo'));
    const [authMode, setAuthMode] = useState(
        promoFromUrl || readUrlParam('ref') ? 'register' : 'login'
    );

    return (
        <section className="panel panel--auth" id="auth">
            <div className="panel__tabs">
                <button
                    type="button"
                    className={authMode === 'login' ? 'active' : ''}
                    onClick={() => setAuthMode('login')}
                >
                    Вход
                </button>

                <button
                    type="button"
                    className={authMode === 'register' ? 'active' : ''}
                    onClick={() => setAuthMode('register')}
                >
                    Регистрация
                </button>
            </div>

            {authMode === 'login' ? <LoginForm /> : <RegisterForm promoCode={promoFromUrl} />}
        </section>
    );
}

export default AuthSection;
